__turbopack_context__.v({
  "job-info": "style-module-scss-module__rHTlqW__job-info",
  "jobs": "style-module-scss-module__rHTlqW__jobs",
});
